import { Button, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import SavingCard from '../supporting-information/saving-card';
import PharmacyReceipt from '../supporting-information/pharmacy-receipt';
import ExplanationOfBenefits from '../supporting-information/explanation-of-benefits';
import InsuranceCard from '../supporting-information/insurance-card';
import LilyButton from '../../../../../components/button/lily-button';
import { useClaimContext } from '../../component/claim-context';
import FillPdfFromAssets from '../../component/pdf/fill-pdf';
import { CheckOutlined } from '@ant-design/icons';

const SupportingInformation = () => {
    const { Title, Text } = Typography;
    const [currentType, setCurrentType] = useState('');

    const { setCurrent, supportOptions, supportingCurrent, setSupportingCurrent } = useClaimContext();

    const allChecked = useMemo(() => {
        return supportOptions.every(item => item.checked === true);
    }, [supportOptions]);

    return (
        <div>
            {
                supportingCurrent === 'claim-form-preview' ? (
                    <div className='d-flex flex-column gap-4'>
                        <Title className='mb-1 main-title' level={3}>
                            Claim Form Preview
                        </Title>
                        <Text>
                            Based off of the information provided, we have generated a claim form. Please review the document to ensure accuracy.
                        </Text>
                        <div className='d-flex justify-content-center'>
                            <FillPdfFromAssets />
                        </div>
                        <div className='d-flex flex-row justify-content-end mt-5'>
                            <Button
                                color="default"
                                variant="link"
                                style={{ width: '200px' }}
                                onClick={() => setSupportingCurrent('')}
                            >
                                Back
                            </Button>
                            <LilyButton disabled={!allChecked} style={{ width: '200px' }} onClick={() => setCurrent(2)} text="Next" />
                        </div>
                    </div>
                ) : (
                    (() => {
                        switch (currentType) {
                            case 'saving-card':
                                return <SavingCard caseType="saving-card" setCurrentType={setCurrentType} />
                            case 'pharmacy-receipt':
                                return <PharmacyReceipt caseType="pharmacy-receipt" setCurrentType={setCurrentType} />
                            case 'eob':
                                return <ExplanationOfBenefits caseType="eob" setCurrentType={setCurrentType} />
                            case 'insurance-card':
                                return <InsuranceCard caseType="insurance-card" setCurrentType={setCurrentType} />
                            default:
                                return (
                                    <div className='d-flex flex-column gap-4'>
                                        <Title className='mb-1 main-title' level={3}>
                                            Supporting Documents
                                        </Title>
                                        <Text>
                                            You will need to review each of the following sections below and attach supporting documentation for the pharmacy receipt, explanation of benefits and insurance card.
                                        </Text>
                                        <div className='d-flex flex-column gap-2'>
                                            {
                                                supportOptions && supportOptions.map((item) => {
                                                    return (
                                                        <div
                                                            className={`doc-option ${item.checked && 'checked'} pointer d-flex flex-row align-items-center gap-3`}
                                                            style={{ cursor: 'pointer' }}
                                                            key={item.value}
                                                            onClick={() => setCurrentType(item.value)}
                                                        >
                                                            <div className={`cus-check-icon ${item.checked && 'checked'}`}>
                                                                {
                                                                    item.checked && (
                                                                        <CheckOutlined style={{ fontSize: '10px', fontWeight: 700 }} />
                                                                    )
                                                                }
                                                            </div>
                                                            <Title className='m-0' level={5} style={{ color: 'black', fontWeight: '400', fontSize: '16px' }}>{item.label}</Title>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className='d-flex flex-row justify-content-end mt-5'>
                                            <Button
                                                color="default"
                                                variant="link"
                                                style={{ width: '200px' }}
                                                onClick={() => setCurrent(0)}
                                            >
                                                Back
                                            </Button>
                                            <LilyButton disabled={!allChecked} style={{ width: '200px' }} onClick={() => setSupportingCurrent('claim-form-preview')} text="Next" />
                                        </div>
                                    </div>
                                )
                        }
                    })()
                )
            }
        </div >
    )
}

export default SupportingInformation